import type { FC, ReactNode } from "react";

import { ModalHeader } from "@aviary";

import { header } from "./SignUpModalHeader.styles";

interface Props {
  children: ReactNode;
}

const SignUpModalHeader: FC<Props> = ({ children }) => {
  return <ModalHeader css={header}>{children}</ModalHeader>;
};

export { SignUpModalHeader };
